<template>
  <div class="modal">
    <TitleArea
      @click-close="onClickClose"
      :showReturn="true"
      :text="option.correct ? '正解！' : '不正解'"
    />
    <div class="modal-content-area">
      <img
        v-if="option.correct"
        class="answer-img"
        src="@/assets/mission/correct.png"
      />
      <img v-else class="answer-img" src="@/assets/mission/wrong.png" />
      <div class="text-wrapper">
        <div class="text-area" :class="{ correct: option.correct }">
          <div v-if="option.correct">{{ option.text }}</div>
          <div v-else>ヒント</div>
        </div>
        <p>{{ explanation }}</p>
      </div>
      <div class="button-area">
        <ButtonTextLink
          v-if="option.correct"
          @click-text="onClickGetPoint"
          :isRed="true"
          text="ポイントゲット!"
        />
        <ButtonTextLink
          v-else
          @click-text="onClickRetry"
          :isRed="true"
          text="再挑戦"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TitleArea from "@/components/Atoms/TitleArea";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "show-mission-area",
  components: {
    TitleArea,
    ButtonTextLink,
  },
  props: {
    option: { type: Object, require: true },
    explanation: { type: String, require: true },
  },
  methods: {
    onClickGetPoint() {
      this.$emit("click-get-point");
    },
    onClickRetry() {
      this.$emit("click-retry");
    },
    onClickClose() {
      this.$emit("click-retry");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.modal {
  background-color: white;
  z-index: 3;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  right: 0;
  .modal-content-area {
    padding: 3rem 0 3rem 0;
    height: calc(100% - 6rem);
    overflow: scroll;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.answer-img {
  height: 40%;
}
.button-area {
  width: calc(100% - 1rem);
  font-weight: 700;
}

.text-wrapper {
  width: calc(100% - 1rem);
  display: flex;
  margin-top: 1vh;
  padding-top: 0.5rem;
  border: 1px solid #5cd5d6;
  border-radius: 12px;
  height: 40%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  > div,
  p {
    width: calc(100% - 1rem);
  }
}

.text-area {
  background: url("../../assets/mission/answer.png");
  background-size: contain;
  background-repeat: no-repeat;
  width: calc(100% - 1rem);
  height: fit-content;
  aspect-ratio: 1252/154;
  display: flex;
  justify-content: center;
  align-items: end;
  position: relative;

  .correct {
    &::after {
      content: "正解は……";
      position: absolute;
      display: block;
      left: 0.25rem;
      font-size: 0.8rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuizMission/AnswerModal.vue